import { Grid, IconProps, Typography } from '@mui/material';
import React from 'react';
import { colors } from '../utils/theme';

export const RootineIconAndText = ({
  icon,
  title,
  description,
}: {
  icon: IconProps;
  title: string;
  description?: string;
}): JSX.Element => {
  return (
    <Grid container flexDirection="row" alignItems="flex-start">
      <Grid item sx={{ mr: 1.5 }}>
        {icon}
      </Grid>
      <Grid
        container
        flexDirection="column"
        flexWrap="nowrap"
        item
        xs={10}
        md={10}
      >
        <Typography fontSize={16} sx={{ fontWeight: 500 }}>
          {title}
        </Typography>
        {description && (
          <Typography
            fontSize={16}
            variant="light"
            sx={{ color: colors.greys.SECONDARY_TEXT_GREY }}
          >
            {description}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};
